const DETAILS_SELECTOR = '.product-information--main-product .product-details:not(.sticky-content--desktop)';
const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
const STICKY_GAP = 16;

class ProductDetailsBottomSticky {
  constructor(element) {
    this.element = element;
    this.frame = null;
    this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
    this.resizeObserver.observe(element);

    const header = document.querySelector('#header-group');
    if (header) this.resizeObserver.observe(header);

    window.addEventListener('resize', this.scheduleUpdate);
    DESKTOP_QUERY.addEventListener('change', this.scheduleUpdate);
    this.scheduleUpdate();
  }

  scheduleUpdate = () => {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.update());
  };

  update() {
    this.frame = null;

    if (!DESKTOP_QUERY.matches) {
      this.element.removeAttribute('data-bottom-sticky');
      this.element.style.removeProperty('--product-details-sticky-top');
      return;
    }

    const headerHeight = document.querySelector('#header-group')?.getBoundingClientRect().height || 0;
    const detailsHeight = this.element.getBoundingClientRect().height;
    const topOffset = Math.min(
      headerHeight + STICKY_GAP,
      window.innerHeight - detailsHeight - STICKY_GAP
    );

    this.element.style.setProperty('--product-details-sticky-top', `${Math.floor(topOffset)}px`);
    this.element.setAttribute('data-bottom-sticky', '');
  }
}

const mountedElements = new WeakSet();

function mountProductDetailsBottomSticky(root = document) {
  for (const element of root.querySelectorAll(DETAILS_SELECTOR)) {
    if (mountedElements.has(element)) continue;
    mountedElements.add(element);
    new ProductDetailsBottomSticky(element);
  }
}

mountProductDetailsBottomSticky();
document.addEventListener('shopify:section:load', (event) => mountProductDetailsBottomSticky(event.target));
